export default __webpack_public_path__ + "static/media/intelbras-brand-complete.804691b4.svg";